export interface SiteConfig {
  name: string;
  domain: string;
  url: string;
  contactEmail: string;
  description: string;
}

/** Injected by Vite from ../config/customer.json — see vite.config.ts */
declare const __SITE_CONFIG__: SiteConfig;

export const site: SiteConfig = __SITE_CONFIG__;
